<template>
    <div id="main-wrapper">
        <AdminNavbar />

        <div class="page-title">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 col-md-12">
                        <h2 class="ipt-title">{{ t('Welcome!') }}</h2>
                    </div>
                </div>
            </div>
        </div>

        <section class="bg-light">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-12 col-md-12">
                        <div class="filter_search_opt">
                            <router-link to="#" @click.prevent="show = !show" class="btn btn-dark full-width mb-4">
                                Dashboard Navigation<i class="fa-solid fa-bars ms-2"></i>
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-12">
                        <AdminSidebar :open="show" @update:open="show = $event" :user="user"/>
                    </div>

                    <div class="col-lg-9 col-md-12">
                        <div class="dashboard-wraper">
                            <div class="form-submit">
                                <h4>{{ t('Change Your Password') }}</h4>
                                <form @submit.prevent="changePassword">
                                    <div class="submit-section">
                                        <div class="row">
                                            <div class="form-group col-lg-6 col-md-6">
                                                <label class="mb-1">{{ t('Current Password') }}</label>
                                                <input type="password" v-model="form.current_password" class="form-control" required>
                                            </div>

                                            <div class="form-group col-md-6">
                                                <label class="mb-1">{{ t('New Password') }}</label>
                                                <input type="password" v-model="form.new_password" class="form-control" required>
                                            </div>

                                            <div class="form-group col-md-6">
                                                <label class="mb-1">{{ t('Confirm Password') }}</label>
                                                <input type="password" v-model="form.new_password_confirmation" class="form-control" required>
                                            </div>

                                            <div class="form-group col-lg-12 col-md-12">
                                                <button class="btn btn-primary px-5 rounded" type="submit" :disabled="loading">
                                                    <span v-if="loading"><i class="fa fa-spinner fa-spin me-2"></i>{{ t('Saving...') }}</span>
                                                    <span v-else>{{ t('Save Changes') }}</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <FooterTop :bg="'theme-bg'" />
        <FooterDark />
        <ScrollToTop />
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useToast } from 'vue-toastification'

import AdminSidebar from '@/components/admin-sidebar.vue'
import AdminNavbar from '@/components/navbar/admin-navbar.vue'
import FooterTop from '@/components/footer/footer-top.vue'
import FooterDark from '@/components/footer/footer-dark.vue'
import ScrollToTop from '@/components/scroll-to-top.vue'

const { t ,locale} = useI18n()
const toast = useToast()
const router = useRouter()

const show = ref(false)
const loading = ref(false)
const user = ref(null) 

onMounted(async () => {
  const token = localStorage.getItem('auth_token')

  if (!token) {
    toast.error(t('You are not logged in.'))
    router.replace('/404')
    return
  }

  try {
    const response = await axios.get('/visitor', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    user.value = response.data.user
  } catch (error) {
    toast.error(t('Failed to load profile information.'))
    router.replace('/404')
  }
})

const form = ref({
  current_password: '',
  new_password: '',
  new_password_confirmation: ''
})

const changePassword = async () => {
  const token = localStorage.getItem('auth_token')

  if (!token) {
    toast.error(t('You are not logged in.'))
    router.replace('/404')
    return
  }

  loading.value = true

  try {
    const response = await axios.post('/visitor/change-password',{ ...form.value, lang: locale.value }, {
      headers: { Authorization: `Bearer ${token}` }
    })

    toast.success(response.data.message || t('Password changed successfully.'))
    form.value = { current_password: '', new_password: '', new_password_confirmation: '' }
  } catch (error) {
    const msg = error.response?.data?.message || t('Failed to change password.')
    toast.error(msg)
  } finally {
    loading.value = false
  }
}
</script>
